module.exports = __webpack_public_path__ + "img/VolumeDownOutlined.aef5901a.svg";